import React, { useState, useEffect, useCallback, useMemo } from 'react';
// generics
import * as S from './styles';
// components
import Loader from '../../Loader';
import TRow from './components/TRow/TRow';
import THeader from './components/THeader';
import { Visibility } from 'components/Visibility';
import IndicatorRefreshButton from 'pages/Quotes/components/IndicatorRefreshButton';
//interfaces
import { TableDetailsProps } from './components/interface';
//context
import { useDetailsQuoteContext } from 'contexts/DetailsQuote';
import { OutPortfolioContextProvider } from 'contexts/OutPortfolio';
import { ConversionFactorContextProvider } from 'contexts/ConversionFactor';
import { ExceptionPriceBelowMinContextProvider } from 'contexts/ExceptionPriceBelowMin';
//services
import DomainSettingService from 'services/domainSetting.service';

export default function TableDetails({
  reset,
  state,
  quoteId,
  cdFilter,
  setReset,
  setHasMore,
  customProps,
  customerCode,
  headerLabels,
  isNoSegmented,
  segmentFilter,
  productSelected,
  setRefreshControl,
  setProductSelected,
  ableNegotiacionBtn,
  orderBudgetHistory,
  distributionCenters,
  refreshTableWithTab,
  refreshQuoteSentHeaderTabs,
  distributionCenterSelected,
  reproveMapProduct,
  approveMapProduct
}: TableDetailsProps) {

  const [notifyTooltipToClose, setNotifyTooltipToClose] = useState({ closeAll: true, modalToBeOpened: '' });
  const [keptSelections, setKeptSelections] = useState<any>(state?.keptSelections);
  const [priceHistoryOpened, setPriceHistoryOpened] = useState(false);
  const [segmentsWithoutPriceLock, setSegmentsWithoutPriceLock] = useState([]);
  const [selectItems, setSelectItems] = useState<any>([]);
  const [listUpdate, setListUpdate] = useState<any>([]);
  const { quoteItem, setQuoteItem, quoteDetail } = useDetailsQuoteContext();

  const _domainSettingService = new DomainSettingService();

  const getSegmentsWithoutPriceLock = async () => {
    const response = await _domainSettingService.get(undefined, undefined, undefined, {
      and: [
        { identifier: { eq: 'SegmentsWithoutPriceLock' } },
        { enabled: { eq: true } },
      ],
    });

    const { data } = response;
    const parseOptionValue: [] = data[0].value.split(",");


    setSegmentsWithoutPriceLock(parseOptionValue);
  };

  useEffect(() => {
    getSegmentsWithoutPriceLock();
  }, []);

  useEffect(() => {
    //to check if there's state
    if ((keptSelections && quoteItem)) {
      const newList = quoteItem.data?.map((item: any) => {
        const { sequenceNumber, isCustomer } = item;
        if (
          keptSelections.includes(sequenceNumber.toString())
          && isCustomer
        ) {
          return { ...item, checked: true };
        } else {
          return item;
        }
      });

      setListUpdate(newList);
      setSelectItems(keptSelections);
      setKeptSelections(undefined);
    } else if (reset) {
      setListUpdate([]);
      setReset(false);
    }
    else {
      //To receive from API items list
      quoteItem && setListUpdate(quoteItem.data);
    }
  }, [quoteItem]);

  const handleSelectItems = useCallback(() => {
    let selected = quoteItem?.data?.filter((item: any) => item.checked);
    setSelectItems(selected);
  }, [quoteItem]);

  const items = useMemo(() => (quoteItem?.data?.filter(i => !i.budgets?.deleted)), [quoteItem]);

  const changeToggle = (sequenceNumber: number, tabs?: any) => {
    if (quoteItem && (isNoSegmented === false || quoteDetail?.integrationMessages && quoteDetail?.integrationMessages?.length > 0)) {
      const newListItems = quoteItem?.data?.filter(i => Number(i.sequenceNumber) !== sequenceNumber);

      if (newListItems && newListItems?.length > 0)
        setQuoteItem({ ...quoteItem, data: newListItems });
      else if (tabs)
        refreshTableWithTab(tabs);
    }
  };

  return (
    <S.TableDnD>
      <S.Table>
        <THeader headerLabels={headerLabels} />
        {
          (!listUpdate || typeof quoteItem === 'undefined') && !quoteItem?.error
            ? (
              <div className="body">
                <Loader size={45} />
              </div>
            ) : (
              <div className="body">
                {items?.map((item: any, i: number) => (
                  <S.Row className="no-alternate-color" key={i}>
                    <ExceptionPriceBelowMinContextProvider>
                      <OutPortfolioContextProvider
                        quoteId={quoteId}
                        changeToggle={changeToggle}
                        productCode={item.productCode}
                        portfolioDb={!item.outPortfolio}
                        sequenceNumber={item.sequenceNumber}
                        buyerIdentifier={item.buyerIdentifier}
                        distributionCenterSelected={segmentFilter || cdFilter?.distributionCenter}
                      >
                        <ConversionFactorContextProvider item={item}>
                          <TRow
                            index={i}
                            item={item}
                            quoteId={quoteId}
                            cdFilter={cdFilter}
                            setHasMore={setHasMore}
                            customProps={customProps}
                            keepSelection={selectItems}
                            changeToggle={changeToggle}
                            customerCode={customerCode}
                            isNoSegmented={isNoSegmented}
                            productSelected={productSelected}
                            setProductSelected={setProductSelected}
                            ableNegotiacionBtn={ableNegotiacionBtn!}
                            orderBudgetHistory={orderBudgetHistory}
                            distributionCenters={distributionCenters}
                            handleChangeSelectItems={handleSelectItems}
                            notifyHistoryOpened={setPriceHistoryOpened}
                            notifyTooltipToClose={notifyTooltipToClose}
                            setNotifyTooltipToClose={setNotifyTooltipToClose}
                            segmentsWithoutPriceLock={segmentsWithoutPriceLock}
                            refreshQuoteSentHeaderTabs={refreshQuoteSentHeaderTabs}
                            distributionCenterSelected={distributionCenterSelected}
                            reproveMapProduct={reproveMapProduct}
                            approveMapProduct={approveMapProduct}
                          />
                        </ConversionFactorContextProvider>
                      </OutPortfolioContextProvider>
                    </ExceptionPriceBelowMinContextProvider>
                  </S.Row>
                ))
                }
                <Visibility visible={quoteItem.error ?? false}>
                  <IndicatorRefreshButton refreshSize='40px' onReload={() => setRefreshControl(true)} />
                </Visibility>
              </div>
            )
        }
      </S.Table>
    </S.TableDnD >
  );
}
